import ModalTemplate from "@/components/ModalTemplate/ModalTemplate";
import InformationBlock from "@/components/InformationBlock/InformationBlock";

import { McsisRole } from "@/models/constants/McsisRole";
import { ActionTypes, GetterTypes } from "@/store-vuex/types";
import { Component, Vue } from "vue-property-decorator";

import AppointmentParticipantForm from "@/components/AppointmentParticipantForm/AppointmentParticipantForm.vue";
import router from "@/router";
import { ParticipantDTO } from "@/models/ParticipantDTO";
import { McsisConstants } from "@/models/constants/McsisConstants";

@Component({
  components: {
    AppointmentParticipantForm,
    ModalTemplate,
    InformationBlock
  }
})
export default class AppointmentParticipant extends Vue {
  public isContactFormInvalid = true;

  /**
   * Get the ParticipantDTO instance from the store
   */
  public get participant(): ParticipantDTO {
    return this.$store.getters[GetterTypes.participant];
  }

  /**
   * Handle the form validity
   *
   * @param value
   */
  public onValidityCheck(value: boolean): void {
    this.isContactFormInvalid = !value;
  }

  /**
   * Go to step 2
   */
  public next() {
    this.$router.push({
      name: McsisConstants.AppointmentDetailsPage,
      params: {
        screening: this.$route.params.screening,
        partId: String(this.$route.params.partId)
      }
    });
  }
}
